// Renderizadores de célula da tabela de clientes do ERP (`renderCell` do
// DataGrid).
import { Box, Chip } from "@mui/material";
import TipoClienteChip from "../../../../../components/tipoCliente/TipoClienteChip";

const estiloTexto = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

// Texto com o conteúdo inteiro no `title`, para quando passa da largura da
// coluna. Usa o valor formatado quando a coluna tem máscara.
export function renderTexto({ value, formattedValue }) {
  const texto = String(formattedValue ?? value ?? "");
  return (
    <Box component="span" title={texto} sx={estiloTexto}>
      {texto}
    </Box>
  );
}

export const criarFormatadorMascara = (mascara) => (value) =>
  mascara(value || "") || "";

// Lista separada por vírgula virando chips.
export function renderChips({ value }) {
  const grupos = String(value || "")
    .split(",")
    .map((grupo) => grupo.trim())
    .filter(Boolean);

  if (!grupos.length) return null;

  return (
    <Box
      title={grupos.join(", ")}
      sx={{
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center",
        gap: 0.5,
        overflow: "hidden",
      }}
    >
      {grupos.map((grupo) => (
        <Chip
          key={grupo}
          label={grupo}
          size="small"
          sx={{ height: 20, fontSize: "0.7rem", maxWidth: "100%" }}
        />
      ))}
    </Box>
  );
}

// Selo PF/PJ. Recebe a linha inteira porque `tipoClienteDe` trata 0 e ausente
// como PJ — olhar só o valor da célula perderia essa regra.
export function renderTipoCliente({ row }) {
  return <TipoClienteChip cliente={row} />;
}
